import {Directive, EventEmitter, HostListener, Output} from '@angular/core';

@Directive({
	selector: '[cassDragNDrop]'
})
export class DragNDropDirective {

	@Output() fileDropped = new EventEmitter<any>();

	constructor() {
	}

	@HostListener('drop', ['$event'])
	public ondrop(evt: any) {
		evt.preventDefault();
		evt.stopPropagation();
		let files = evt.dataTransfer.files;
		if (files.length > 0) {
			this.fileDropped.emit(files);
		}
	}

}
